<template>
  <div class="chinese-box">
    <div class="chinese-box-icon" @click="subscribe">
      <i class="el-icon-lock"></i>
    </div>
    <div class="chinese-box-tip">
      <div>继续阅读，请点击订阅会员</div>
<!--      <div class="chinese-box-tip-line">-->
<!--        <img src="~@/assets/chinese_logo.png" />-->
<!--        <span>订阅</span>-->
<!--      </div>-->
    </div>
    <div class="chinese-box-btn" @click="subscribe">立即订阅</div>
    <div class="chinese-box-desc" v-if="!isLogin">
      <span class="chinese-box-desc-text">已是VIP会员？</span>
      <div class="chinese-box-desc-btn" @click="login">登录</div>
    </div>
    <chinese-lock ref="chineseLockRef" :report="report" @unlock="unlock" @login="login"></chinese-lock>
  </div>
</template>

<script>
import ChineseLock from "./chineseLock";
export default {
  name: "ChineseBox",
  components: {
    ChineseLock
  },
  props: {
    // 报告详情
    report: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return {
      isLogin: false,
    }
  },
  created() {
    let token = localStorage.getItem("cf40-token");
    if (token) {
      this.isLogin = true;
    } else  {
      this.isLogin = false;
    }
  },
  methods: {
    // 登录
    login() {
      this.$emit("login");
    },
    // 解锁当前文章
    unlock() {
      this.$emit("unlock");
    },
    // 订阅
    subscribe() {
      this.$refs.chineseLockRef.open();
    }
  }
}
</script>
<style lang="scss" scoped>
.chinese-box {
  &-icon {
    cursor: pointer;
    text-align: center;
    font-size: 80px;
    color: #ed6f33;
  }
  &-tip {
    font-size: 32px;
    text-align: center;
    &-line {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        height: 32px;
        margin-right: 20px;
      }
    }
  }
  &-btn {
    margin: 50px auto auto;
    cursor: pointer;
    user-select: none;
    padding: 20px 50px;
    color: #ffffff;
    font-size: 38px;
    font-family: HarmonyOS_Bold;
    background-color: #ed6f33;
    display: table;
    &:hover {
      background-color: #f58652;
    }
  }
  &-desc {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    &-text {
      margin-right: 15px;
    }
    &-btn {
      font-size: 22px;
      cursor: pointer;
      user-select: none;
      padding: 6px 20px;
      color: #ffffff;
      background-color: #747474;
      &:hover {
        background-color: #898686;
      }
    }
  }
}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .chinese-box {
    &-icon {
      font-size: 60px;
    }
    &-tip {
      line-height: 32px;
      font-size: 22px;
      text-align: center;
      &-line {
        img {
          height: 22px;
          margin-right: 20px;
        }
      }
    }
    &-btn {
      margin-top: 30px;
      font-size: 28px;
    }
    &-desc {
      margin-top: 20px;
      margin-bottom: 50px;
      font-size: 20px;
      &-text {
        margin-right: 15px;
      }
    }
  }
}
</style>